import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';

export const BerandaPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);

  // Set page title
  useEffect(() => {
    document.title = 'Park Serpong - Rumah #LebihMasukAkal di Jl. Raya Legok, Tangerang';
  }, []);

  // Detect device orientation
  useEffect(() => {
    const checkOrientation = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    return () => window.removeEventListener('resize', checkOrientation);
  }, []);

  // Hero images
  const landscapeImages = [
    '/images/beranda/park_serpong.jpeg',
    '/images/beranda/TAHAP 1.jpg',
    '/images/beranda/TAHAP 2.jpg',
    '/images/beranda/TAHAP 3.jpg',
    '/images/beranda/TAHAP 3 BLACKSTAR_.jpg',
    '/images/beranda/TAHAP 3 CENDANA.jpg',
    '/images/beranda/TAHAP 4.jpg',
    '/images/beranda/TAHAP 5.jpg',
    '/images/beranda/TAHAP 5.1.jpg',
    '/images/beranda/TAHAP 5.2.jpg',
    '/images/beranda/TAHAP 5.3.jpg',
    '/images/beranda/TAHAP 6.jpg',
  ];

  const portraitImages = [
    '/images/beranda/park_serpong.jpeg',
    '/images/beranda/TAHAP 1.jpg',
    '/images/beranda/TAHAP 2.jpg',
    '/images/beranda/TAHAP 3.jpg',
    '/images/beranda/TAHAP 3 BLACKSTAR_.jpg',
    '/images/beranda/TAHAP 3 CENDANA.jpg',
    '/images/beranda/TAHAP 4.jpg',
    '/images/beranda/portrait1.jpeg',
    '/images/beranda/portrait2.jpeg',
    '/images/beranda/TAHAP 6.jpg',
  ];

  const heroImages = isPortrait ? portraitImages : landscapeImages;

  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  return (
    <div className="min-h-screen">
      {/* Navbar */}
      <Navbar scrolled={isScrolled} currentPage="beranda" />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden w-full bg-gray-900" data-testid="hero-section">
        {/* Slideshow */}
        <div className="absolute inset-0 w-full">
          {heroImages.map((img, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={img}
                alt={`Park Serpong Slide ${index + 1}`}
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/60"></div>
            </div>
          ))}
        </div>

        {/* Hero Content */}
        <div className="relative z-10 text-center text-white px-4 max-w-full">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 drop-shadow-2xl">
            Park Serpong
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl mb-6 md:mb-8 font-light drop-shadow-lg">
            #LebihMasukAkal
          </p>
          <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto drop-shadow-lg">
            Kawasan Kota Mandiri 400 Hektar di Jl. Raya Legok, Tangerang
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/produk"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 md:px-10 py-3 md:py-4 rounded-lg text-lg md:text-xl font-semibold transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105"
            >
              Lihat Produk
            </Link>
            <Link
              to="/tentang"
              className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white px-8 md:px-10 py-3 md:py-4 rounded-lg text-lg md:text-xl font-semibold transition-all duration-300 border-2 border-white"
            >
              Tentang Kami
            </Link>
          </div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-2 md:left-8 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white rounded-full p-2 md:p-4 transition-all duration-300 hover:scale-110 shadow-xl"
        >
          <svg className="w-5 h-5 md:w-8 md:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 md:right-8 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white rounded-full p-2 md:p-4 transition-all duration-300 hover:scale-110 shadow-xl"
        >
          <svg className="w-5 h-5 md:w-8 md:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-1.5 md:gap-2 z-20 bg-black/30 backdrop-blur-sm px-3 py-2 rounded-full">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-white w-6 md:w-8 h-2.5 md:h-3' 
                  : 'bg-white/50 hover:bg-white/75 w-2.5 md:w-3 h-2.5 md:h-3'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Rumah Impian di Kawasan Kota Mandiri
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-8">
              Park Serpong kawasan kota mandiri menghadirkan banyak pilihan rumah dengan harga mulai Rp 299 Juta, ruko komersil serta lahan kavling di lokasi strategis JI.
Raya Legok, Tangerang. Dekat Gading Serpong (5 menit), Lippo Karawaci (5 menit), dan BSD City (15 menit).
            </p>
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">400 Ha</div>
                <p className="text-gray-600">Luas Kawasan</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">30+</div>
                <p className="text-gray-600">Tipe Rumah</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">7</div>
                <p className="text-gray-600">Fase Pengembangan</p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/produk"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all hover:scale-105"
              >
                Jelajahi Produk
              </Link>
              <Link
                to="/tentang"
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-lg text-lg font-semibold transition-all"
              >
                Pelajari Lebih Lanjut
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
